{
  "generic.edit": "Edit",
  "generic.delete": "Delete",
  "generic.update": "Update",
  "generic.create": "Create",
  "generic.cancel": "Cancel",
  "generic.confirm": "Confirm",
  "generic.print": "Print",
  "generic.close": "Close",
  "generic.save": "Save",
  "generic.save-validation": "Please fix errors in the form.",

  "input.select-certificate": "Select a certificate",
  "input.select-checklist": "Select a checklist",
  "input.select-function": "Select a function",
  "input.select-organisation": "Select an organisation",
  "input.select-safety-instruction": "Select a safety instruction",

  "context-menu.tab-actions.close": "Close tab",
  "context-menu.tab-actions.close-all": "Close all tabs",
  "context-menu.tab-actions.close-others": "Close other tabs",
  "context-menu.tab-actions.split-horizontal": "Split horizontally",
  "context-menu.tab-actions.split-vertical": "Split vertically",
  "context-menu.tab-open.open": "Open",
  "context-menu.tab-open.open-right": "Open right",
  "context-menu.tab-open.open-bottom": "Open bottom",
  "menu.organisations": "Organisations",
  "menu.people": "Persons",
  "menu.projects": "Projects",
  "menu.certificates": "Certificates",
  "menu.safety": "Safety reports",
  "menu.content": "Content",
  "menu.thesaurus": "Thesaurus",
  "auth.login.title": "Login to the i-LOP platform portal",
  "auth.login.description": "Use your i-LOP account to log in to the platform portal.",
  "auth.login.form.email": "Email address",
  "auth.login.form.email.placeholder": "Enter your email address",
  "auth.login.form.password": "Password",
  "auth.login.form.password.placeholder": "Enter your password",
  "auth.login.form.submit": "Login",
  "auth.login.form.forgot": "Forgot password?",
  "auth.forgot-password.title": "Forgot password",
  "auth.forgot-password.description": "No problem! Just enter your email address below and click 'Send reset link'. If your email address is known to us, you will receive a link to reset your password.",
  "auth.forgot-password.form.email": "Email address",
  "auth.forgot-password.form.email.placeholder": "Enter your email address",
  "auth.forgot-password.form.submit": "Send reset link",
  "auth.forgot-password.form.back-to-login": "Back to login",
  "auth.forgot-password.form.success.sent-to": "We sent a confirmation email to",
  "auth.forgot-password.form.success.check-email": "Check your email and click on the confirmation link to continue.",
  "auth.reset-password.title": "Reset password",
  "auth.reset-password.description": "You have chosen to reset your password. Use the form below to enter your new password. Once you’ve updated it, you will need to log in again.",
  "auth.reset-password.form.password": "New password",
  "auth.reset-password.form.password.placeholder": "Enter your new password",
  "auth.reset-password.form.password-confirm": "Confirm new password",
  "auth.reset-password.form.password-confirm.placeholder": "Enter your new password again",
  "auth.reset-password.form.submit": "Change password",
  "auth.reset-password.form.success": "Your password has been changed successfully. You can now log in with your new password.",
  "auth.reset-password.form.back-to-login": "Back to login",
  "auth.reset-password.form.password-mismatch": "The passwords do not match. Please check your input and try again.",
  "auth.accept-invitation.title": "Create account",
  "auth.accept-invitation.description": "An administrator has invited you to create an account on the i-LOP platform using {{email}}. Your details have already been filled in — all you need to do is set a password.",
  "auth.accept-invitation.form.password": "Password",
  "auth.accept-invitation.form.password.placeholder": "Enter your password",
  "auth.accept-invitation.form.password-confirm": "Confirm password",
  "auth.accept-invitation.form.password-confirm.placeholder": "Enter your password again",
  "auth.accept-invitation.form.submit": "Create account",
  "auth.accept-invitation.form.password-mismatch": "The passwords do not match. Please check your input and try again.",
  "auth.accept-invitation.invalid-token.title": "Invalid link",
  "auth.accept-invitation.invalid-token.description": "The link you used is not valid anymore. An account has already been created, or it has expired.",
  "table.per-page": "Items per page:",
  "table.empty.title": "No data found",
  "table.empty.sub-title": "There have been no results for your current selection. Try adjusting your filters or create a new item.",
  "table.toast.error": "Something went wrong while fetching the data",
  "organisations.table.logo": "Logo",
  "organisations.table.organisation-name": "Organisation Name",
  "organisations.table.business-registry-number": "Chamber of Commerce number",
  "organisations.table.city": "City",
  "organisations.table.street-name": "Street",
  "organisations.table.website": "Website",
  "organisations.new": "New Organisation",
  "organisations.title": "List of Organisations",
  "organisation-edit.edit-title": "Edit Organisation",
  "organisation-edit.new-title": "New Organisation",
  "organisation-edit.delete-button": "Delete Organisation",
  "organisation-edit.delete-title": "Delete Organisation",
  "organisation-edit.delete-confirm": "Delete",
  "organisation-edit.delete-message": "Are you sure you want to delete this organisation?",
  "organisation-edit.delete-success": "Organisation deleted successfully.",
  "organisation-edit.delete-error": "An error occurred while deleting the organisation.",
  "organisation-edit.manage-role-assignments": "Manage Role Assignments",
  "organisation-edit.manage-safety-requirements": "Manage Safety Requirements",
  "organisation-form.general-data": "General data",
  "organisation-form.visitor-address": "Visitor address",
  "organisation-form.postal-address": "Postal address",
  "organisation-form.active": "Active",
  "organisation-form.logo": "Logo",
  "organisation-form.click-to-upload-logo": "Click to upload logo",
  "organisation-form.remove-logo": "Remove logo",
  "organisation-form.coc-number": "Chamber of Commerce number",
  "organisation-form.organisation-name": "Organisation name",
  "organisation-form.description": "Description",
  "organisation-form.parent-organisation": "Parent organisation",
  "organisation-form.email-address": "Email address",
  "organisation-form.website": "Website",
  "organisation-form.phone-number": "Phone number",
  "organisation-form.oin-number": "OIN number",
  "organisation-form.city": "City",
  "organisation-form.street": "Street",
  "organisation-form.house-number": "House Number",
  "organisation-form.zip-code": "Postal code",
  "organisation-form.save-success": "Organisation saved successfully.",
  "organisation-form.save-error": "An error occurred while saving the organisation.",
  "organisation-form.save-validation": "Please fix errors in the form.",
  "PlatformAdmin": "Platform administrator",
  "app-role.View": "View",
  "app-role.Admin": "Admin",
  "app-role.SafetyCoordinator": "Safety Coordinator",
  "toast.error": "Error",
  "toast.success": "Success",
  "toast.warning": "Warning",
  "toast.info": "Information",
  "password-complexity.requirements": "Passwords must contain at least:",
  "password-complexity.min-length": "At least {{minLength}} characters",
  "password-complexity.uppercase": "At least one uppercase letter",
  "password-complexity.lowercase": "At least one lowercase letter",
  "password-complexity.digit": "At least one number",
  "password-complexity.special-char": "At least one special character",
  "errors.authentication.invalid": "Your email address or password is incorrect",
  "errors.authentication.try_later": "It is currently not possible to log in. Please try again later.",
  "errors.authentication.generic": "Something went wrong while logging in. Please try again.",
  "errors.reset.generic": "Potentially this token has already been used or has expired. Please try again.",
  "errors.invitation.generic": "Potentially this token has already been used or has expired. Please try again.",
  "auth.invalid-role.title": "No access",
  "auth.invalid-role.description": "You do not have access to this application with this account. Please contact your system administrator for more information.",
  "auth.invalid-role.back-to-login": "Back to login",
  "context-menu.account.logout": "Logout",
  "errors.generic": "An error occurred. Please try again later.",
  "errors.person.email-duplicate": "A person with this email address already exists.",
  "organisation-edit.admins": "Admins",
  "invite-or-add-person-modal.title": "Invite or add person",
  "invite-or-add-person-modal.description": "Use this modal to invite a new person or add an existing person to the organisation. First, enter the email address of the person you want to add. If they are not registered yet, you need to fill in their details.",
  "invite-or-add-person-modal.step2.description": "This person does not exist yet. Please fill in the details below.",
  "invite-or-add-person-modal.step3.description": "Now, select the role of the person you want to add.",
  "invite-or-add-person-modal.form.email": "Email address",
  "invite-or-add-person-modal.form.email.placeholder": "Enter the email address of the person you want to add",
  "invite-or-add-person-modal.form.first-name": "First name",
  "invite-or-add-person-modal.form.first-name.placeholder": "Enter first name",
  "invite-or-add-person-modal.form.last-name": "Last name",
  "invite-or-add-person-modal.form.last-name.placeholder": "Enter last name",
  "invite-or-add-person-modal.form.function": "Function",
  "invite-or-add-person-modal.form.function.placeholder": "Enter function",
  "invite-or-add-person-modal.form.role": "Role",
  "invite-or-add-person-modal.form.role.placeholder": "Select role",
  "invite-or-add-person-modal.form.send-invitation": "Send invitation immediately",
  "invite-or-add-person-modal.next": "Next",
  "invite-or-add-person-modal.cancel": "Cancel",
  "invite-or-add-person-modal.back": "Back",
  "invite-or-add-person-modal.create": "Add",
  "edit-person-role-modal.title": "Edit person's role",
  "edit-person-role-modal.description": "Use this modal to edit the person's role within the organisation.",
  "edit-person-role-modal.form.role": "Role",
  "edit-person-role-modal.form.role.placeholder": "Select role",
  "edit-person-role-modal.save": "Save",
  "edit-person-role-modal.cancel": "Cancel",
  "context-menu.person-reference.remove": "Remove person",
  "context-menu.person-reference.change-role": "Change role",
  "projects.table.logo": "Logo",
  "projects.table.project-name": "Project Name",
  "projects.table.project-code": "Project Code",
  "projects.table.client": "Client",
  "projects.table.contractor": "Contractor",
  "projects.table.owner": "Owner",
  "projects.table.city": "City",
  "projects.table.street-name": "Street",
  "projects.new": "New Project",
  "projects.title": "List of Projects",
  "project-edit.title-edit": "Edit Project",
  "project-edit.title-new": "New Project",
  "project-edit.delete": "Delete Project",
  "project-edit.close": "Close",
  "project-edit.manage-role-assignments": "Manage Role Assignments",
  "project-edit.manage-safety-requirements": "Manage Safety Requirements",
  "project-edit.delete-button": "Delete Project",
  "project-edit.delete-title": "Delete Project",
  "project-edit.delete-message": "Are you sure you want to delete this project?",
  "project-edit.delete-confirm": "Delete",
  "project-edit.delete-success": "Project deleted successfully.",
  "project-edit.delete-error": "An error occurred while deleting the project.",
  "project-edit.qr-code-button": "QR Code",
  "project-edit.qr-code-modal-title": "Project QR Code",
  "project-edit.qr-code-modal-alt": "Project QR code image",
  "project-form.general-data": "General data",
  "project-form.address": "Address",
  "project-form.title": "Title",
  "project-form.logo": "Logo",
  "project-form.click-to-upload-logo": "Click to upload logo",
  "project-form.remove-logo": "Remove logo",
  "project-form.active": "Active",
  "project-form.description": "Description",
  "project-form.project-code": "Project Code",
  "project-form.client": "Customer",
  "project-form.contractor": "Contractor",
  "project-form.owner": "Owner",
  "project-form.chief-safety-officer": "Chief safety officer:",
  "project-form.start-date": "Start Date",
  "project-form.end-date": "End Date",
  "project-form.city": "City",
  "project-form.street": "Street",
  "project-form.house-number": "House Number",
  "project-form.zip-code": "Postal code",
  "project-form.organisation-none": "None",
  "project-form.admins": "Project Administrators",
  "project-form.responsibilities": "Responsibilities",
  "project-form.safety-contact": "Safety Contact",
  "project-form.safety-contact.select": "Select Safety Contact",
  "project-form.safety-director": "Safety Director",
  "project-form.safety-director.select": "Select Safety Director",
  "project-form.project-risks": "Project Risks",
  "project-form.collision-hazard": "Collision Hazard",
  "project-form.falling-from-height": "Falling from Height",
  "project-form.electrocution": "Electrocution",
  "project-form.hoisting-and-transport": "Hoisting and Transport",
  "project-form.hazardous-substances": "Hazardous Substances",
  "project-form.save-success": "Project saved successfully.",
  "project-form.save-error": "An error occurred while saving the project.",
  "project-form.save-validation": "Please fix errors in the form.",
  "project-form.load-error": "Error loading the project",
  "project-form.load-client-error": "An error occurred while loading the client organisation.",
  "certificates.title": "List of Certificates",
  "certificates.new": "New Certificate",
  "certificates.logo": "Logo",
  "certificates.name": "Name",
  "certificates.description": "Description",
  "certificates.issuingOrganisations": "Issuing Organisations",
  "certificates.gracePeriod": "Grace Period",
  "certificates.days": "days",
  "certificates.newTitle": "New Certificate",
  "certificates.editTitle": "Edit Certificate",
  "certificates.loadError": "Error loading certificate",
  "certificates.loadOrganisationsError": "Error loading organisations",
  "certificates.loadRegistriesError": "Error loading certificate registries",
  "certificates.createSuccess": "Certificate created successfully",
  "certificates.createError": "Error creating certificate",
  "certificates.updateSuccess": "Certificate updated successfully",
  "certificates.updateError": "Error updating certificate",
  "certificates.deleteSuccess": "Certificate deleted successfully",
  "certificates.deleteError": "Error deleting certificate",
  "certificates.logoRequired": "Logo is required for new certificates",
  "certificates.fileError": "Error processing file",
  "certificates.error.registryConflict": "This Registry Source is already assigned to another certificate",
  "certificates.invalidFileType": "Please select a valid image file",
  "certificates.fileTooLarge": "File size must be less than 5MB",
  "certificates.confirmDelete.title": "Delete Certificate",
  "certificates.confirmDelete.message": "Are you sure you want to delete this certificate?",
  "certificates.form.name": "Certificate Name",
  "certificates.form.namePlaceholder": "Enter certificate name",
  "certificates.form.description": "Description",
  "certificates.form.descriptionPlaceholder": "Enter certificate description",
  "certificates.form.logo": "Logo",
  "certificates.form.logoPlaceholder": "Choose certificate logo",
  "certificates.form.logoBackgroundColor": "Logo Background Color",
  "certificates.form.logoBackgroundColorPlaceholder": "Enter background color (e.g., #ffffff)",
  "certificates.form.issuingOrganisation": "Issuing Organisation",
  "certificates.form.issuingOrganisationPlaceholder": "Select issuing organisation",
  "certificates.form.issuingOrganisations": "Issuing Organisations",
  "certificates.form.issuingOrganisationsPlaceholder": "Select issuing organisations",
  "certificates.form.gracePeriod": "Grace Period (Days)",
  "certificates.form.gracePeriodPlaceholder": "Enter grace period in days",
  "certificates.form.registrySource": "Registry Source",
  "certificates.form.registrySourcePlaceholder": "Select registry source (optional)",
  "certificates.form.validityYears": "Validity period (Years, optional)",
  "certificates.form.validityYearsPlaceholder": "Enter validity period",
  "common.edit": "Edit",
  "common.delete": "Delete",
  "common.actions": "Actions",
  "common.create": "Create",
  "common.update": "Update",
  "common.global": "Global",
  "project-form.end-date-before-start-date": "The end date cannot be before the start date.",
  "persons.table.avatar": "Avatar",
  "persons.table.first-name": "First Name",
  "persons.table.last-name": "Last Name",
  "persons.table.email": "Email",
  "persons.table.organisation": "Organisation",
  "persons.table.last-login": "Last login",
  "persons.table.never-logged-in": "Never logged in",
  "persons.table.actions": "Actions",
  "persons.table.actions.invite": "Send invitation",
  "persons.table.actions.reinvite": "Resend invitation",
  "persons.table.invitation-status": "Invitation Status",
  "persons.new": "New Person",
  "persons.title": "List of Persons",
  "persons.already-has-account": "This person already has an account",
  "persons.invitation-sent": "Invitation sent successfully",
  "persons.invitation-status.accepted": "Accepted",
  "persons.invitation-status.expired": "Expired",
  "persons.invitation-status.invited": "Invited",
  "persons.invitation-status.not-invited": "Not invited",
  "person-edit.title-edit": "Edit Person",
  "person-edit.title-new": "New Person",
  "person-edit.delete": "Delete Person",
  "person-edit.close": "Close",
  "person-edit.delete-button": "Delete Person",
  "person-edit.delete-title": "Delete Person",
  "person-edit.delete-message": "Are you sure you want to delete this person?",
  "person-edit.delete-confirm": "Delete",
  "person-edit.delete-success": "Person deleted successfully.",
  "person-edit.delete-error": "An error occurred while deleting the person.",
  "person-edit.already-has-account": "This person already has an account",
  "person-edit.invitation-sent": "Invitation sent successfully",
  "person-edit.invite-button": "Send invitation",
  "person-edit.reinvite-button": "Resend invitation",
  "person-form.avatar": "Avatar",
  "person-form.avatar.remove": "Remove avatar",
  "person-form.general-data": "General data",
  "person-form.first-name": "First Name",
  "person-form.first-name.placeholder": "Enter first name",
  "person-form.last-name": "Last Name",
  "person-form.last-name.placeholder": "Enter last name",
  "person-form.email": "Email",
  "person-form.email.placeholder": "Enter email address",
  "person-form.active": "Active",
  "person-form.gender": "Gender",
  "person-form.gender.male": "Male",
  "person-form.gender.female": "Female",
  "person-form.gender.other": "Other",
  "person-form.date-of-birth": "Date of Birth",
  "person-form.date-of-birth.placeholder": "Enter date of birth",
  "person-form.function": "Function",
  "person-form.function.placeholder": "Enter function",
  "person-form.organisation": "Organisation",
  "person-form.organisation.placeholder": "Select organisation",
  "person-form.role": "Role",
  "person-form.role.placeholder": "Select role",
  "person-form.employments": "Employments",
  "person-form.save-success": "Person saved successfully.",
  "person-form.save-error": "An error occurred while saving the person.",
  "person-form.save-validation": "Please fix errors in the form.",
  "employment.create-title": "Add new employment",
  "employment.edit-title": "Edit employment",
  "employment.organisation": "Organisation",
  "employment.organisation-placeholder": "Select organisation",
  "employment.function": "Function",
  "employment.function-placeholder": "Select function",
  "employment.start-date": "Start date",
  "employment.end-date": "End date (optional)",
  "employment.managerial": "Managerial",
  "employment.managerial-label": "Employee had a managerial role",
  "employment.active": "Active",
  "employment.inactive": "Inactive",
  "employment.create-success": "Employment created successfully.",
  "employment.create-error": "An error occurred while creating the employment.",
  "employment.update-success": "Employment updated successfully.",
  "employment.update-error": "An error occurred while updating the employment.",
  "employment.delete-success": "Employment deleted successfully.",
  "employment.delete-error": "An error occurred while deleting the employment.",
  "employment.delete-confirm-title": "Delete Employment",
  "employment.delete-confirm-message": "Are you sure you want to delete this employment? This action cannot be undone.",
  "employment.person-not-saved-error": "Please save the person first before adding employments.",
  "employment.timeline.no-employments": "No employment history available.",
  "employment.timeline.add-employment": "Add employment",
  "employment.timeline.present": "Present",
  "create-or-edit-person-certificate-modal.title": "Manage certificate",
  "create-or-edit-person-certificate-modal.description": "Use this modal to create or edit a certificate for the person.",
  "create-or-edit-person-certificate-modal.form.certificate": "Certificate",
  "create-or-edit-person-certificate-modal.form.issued-on": "Issued on",
  "create-or-edit-person-certificate-modal.form.issued-on.placeholder": "Select date",
  "create-or-edit-person-certificate-modal.form.expires-on": "Valid until",
  "create-or-edit-person-certificate-modal.form.expires-on.placeholder": "Select date",
  "create-or-edit-person-certificate-modal.form.save": "Save",
  "create-or-edit-person-certificate-modal.form.cancel": "Cancel",
  "person-form.issued-on": "Issued on",
  "context-menu.generic-update-delete.edit": "Edit",
  "context-menu.generic-update-delete.delete": "Delete",
  "person-edit.certificates": "Certificates",

  "select-person-modal.title": "Select Person",
  "select-person-modal.description": "Use this modal to select a person for the project. First, enter the email address of the person. If they are not registered yet, you need to fill in their details.",
  "select-person-modal.step2.description": "This person does not exist yet. Please fill in the details below.",
  "select-person-modal.form.email": "Email address",
  "select-person-modal.form.email.placeholder": "Enter the email address of the person",
  "select-person-modal.form.first-name": "First name",
  "select-person-modal.form.first-name.placeholder": "Enter first name",
  "select-person-modal.form.last-name": "Last name",
  "select-person-modal.form.last-name.placeholder": "Enter last name",
  "select-person-modal.form.function": "Function",
  "select-person-modal.form.function.placeholder": "Enter function",
  "select-person-modal.next": "Next",
  "select-person-modal.cancel": "Cancel",
  "select-person-modal.back": "Back",
  "select-person-modal.select": "Select",

  "role-assignments.title": "Role Assignments",
  "role-assignments.search-placeholder": "Search persons or organisations...",
  "role-assignments.role-placeholder": "Select a role...",
  "role-assignments.add-assignment": "Add Assignment",
  "role-assignments.avatar-alt": "Avatar or logo",
  "role-assignments.send-invite-to": "Send invite to:",
  "role-assignments.edit-title": "Edit Role Assignment",
  "role-assignments.principal-label": "Principal",
  "role-assignments.role-label": "Role",
  "role-assignments.save": "Save",
  "role-assignments.saving": "Saving...",
  "role-assignments.role-required": "Role is required.",
  "role-assignments.update-success": "Role updated successfully",
  "role-assignments.update-error": "Failed to update role",
  "role-assignments.add-error": "Failed to add role assignment.",
  "role-assignments.delete-error": "Failed to delete role assignment.",
  "role-assignments.add-validation": "Please select a person/organisation and a role.",
  "role-assignments.name": "Name",
  "role-assignments.email": "Email",
  "role-assignments.type": "Type",
  "role-assignments.role": "Role",
  "role-assignments.delete-title": "Delete Role Assignment",
  "role-assignments.delete-message": "Are you sure you want to delete this role assignment?",
  "safety-reports.title-all": "All safety reports",
  "safety-reports.category.Accident": "Accident",
  "safety-reports.category.UnsafeSituation": "Unsafe situation",
  "safety-reports.category.SafeSituation": "Safe situation",
  "safety-reports.status.New": "New",
  "safety-reports.status.InProgress": "In progress",
  "safety-reports.status.Solved": "Solved",
  "safety-reports.status.OnHold": "On hold",
  "safety-reports.table.status": "Status",
  "safety-reports.table.reporter": "Reporter",
  "safety-reports.table.project": "Project",
  "safety-reports.table.assigned-to": "Assigned to",
  "safety-reports.table.description": "Description",
  "safety-reports.table.category": "Category",
  "safety-reports.table.date-created": "Date created",
  "safety-reports.unassigned": "Unassigned",
  "safety-report-detail.error.title": "Failed to load safety report",
  "safety-report-detail.title": "Safety report #{{id}}",
  "safety-report-detail.urgent": "Urgent",
  "safety-report-detail.normal": "Normal",
  "safety-report-detail.anonymous": "Anonymous",
  "safety-report-detail.sections.details": "Details",
  "safety-report-detail.sections.status": "Status",
  "safety-report-detail.sections.logs": "Logs",
  "safety-report-detail.sections.comments": "Comments",
  "safety-report-detail.fields.project": "Project",
  "safety-report-detail.fields.reporter": "Reporter",
  "safety-report-detail.fields.category": "Category",
  "safety-report-detail.fields.urgency": "Urgency",
  "safety-report-detail.fields.created-at": "Created at",
  "safety-report-detail.fields.solved-at": "Solved at",
  "safety-report-detail.fields.description": "Description",
  "safety-report-detail.fields.risk": "Risk",
  "safety-report-detail.fields.photos": "Photos",
  "safety-report-detail.fields.current-status": "Current status",
  "safety-report-detail.fields.assigned-to": "Assigned to",
  "safety-report-detail.unassigned": "Unassigned",
  "safety-report-detail.status-editing-note": "Status and assignment can only be changed by users with the right permissions.",
  "safety-report-detail.no-logs": "No logs available.",
  "safety-report-detail.log.created": "Report created by {{actorName}}",
  "safety-report-detail.log.status-changed": "Status changed by {{actorName}} to {{newStatus}}",
  "safety-report-detail.log.commented": "Comment added by {{actorName}}",
  "safety-report-detail.log.assigned": "Assigned to {{assignedToPersonName}} by {{actorName}}",
  "safety-report-detail.log.unassigned": "Unassigned from person by {{actorName}}",
  "safety-report-detail.log.unknown": "Unknown log entry",
  "safety-report-detail.save-success": "Safety report updated successfully.",
  "safety-report-detail.save-error": "Failed to update safety report.",
  "safety-report-detail.validation-error": "Please fix errors in the form.",

  "safety-reports.create-new": "New Safety Report",
  "safety-report-create.title": "Create Safety Report",
  "safety-report-form.general-information": "General Information",
  "safety-report-form.details": "Details",
  "safety-report-form.category": "Category",
  "safety-report-form.project": "Project",
  "safety-report-form.risk-category": "Risk Category",
  "safety-report-form.risk": "Risk",
  "safety-report-form.description": "Description",
  "safety-report-form.photos": "Photos",
  "safety-report-form.click-to-upload-photos": "Click to upload photos",
  "safety-report-form.selected-photos": "Selected Photos",
  "safety-report-form.urgent": "Urgent",
  "safety-report-form.solved": "Solved",
  "safety-report-form.create-success": "Safety report created successfully.",
  "safety-report-form.create-error": "An error occurred while creating the safety report.",
  "safety-report-form.validation-error": "Please fix errors in the form.",
  "safety-report-form.description-or-photos-required": "Either description or photos is required.",
  "safety-report-form.invalid-file-type": "Invalid file type. Please select an image file.",
  "safety-report-form.file-too-large": "File size too large. Maximum size is 5MB.",

  "safety-report.fields.actions-taken": "Actions Taken",
  "safety-report.fields.victims": "Victims",
  "safety-report.fields.absenteeism": "Absenteeism",
  "safety-report.fields.hospitalised": "Hospitalised",

  "safety-report-detail.add-comment": "Add comment",
  "safety-instructions.title": "Safety Instructions",
  "safety-instructions.create": "New Safety Instruction",
  "safety-instructions.table.title": "Title",
  "safety-instructions.table.type": "Type",
  "safety-instructions.table.organisation": "Organisation",
  "safety-instructions.table.status": "Status",
  "safety-instructions.edit.title": "Edit Safety Instruction",
  "safety-instructions.new.title": "New Safety Instruction",
  "safety-instructions.delete-button": "Delete Safety Instruction",
  "safety-instructions.delete-title": "Delete Safety Instruction",
  "safety-instructions.delete-message": "Are you sure you want to delete this safety instruction?",
  "safety-instructions.delete-confirm": "Delete",

  "safety-instructions.create-modal.header": "Create safety instruction",
  "safety-instructions.create-modal.title": "Title",
  "safety-instructions.create-modal.title.required": "Title is required",
  "safety-instructions.create-modal.type": "Type",
  "safety-instructions.create-modal.type.generic": "Generic",
  "safety-instructions.create-modal.type.video": "Video",
  "safety-instructions.create-modal.type.required": "Type is required",
  "safety-instructions.create-modal.organisation": "Organisation",
  "safety-instructions.create-modal.organisation.required": "Organisation is required",
  "safety-instructions.create-modal.cancel": "Cancel",
  "safety-instructions.create-modal.create": "Create",

  "safety-instruction-form.details": "Details",
  "safety-instruction-form.name": "Name",
  "safety-instruction-form.type": "Type",
  "safety-instruction-form.type.Generic": "Generic",
  "safety-instruction-form.type.Video": "Video",
  "safety-instruction-form.created-by": "Created by",
  "safety-instruction-form.organisation": "Organisation",
  "safety-instruction-form.click-to-upload-thumbnail": "Click to upload thumbnail",
  "safety-instruction-form.thumbnail": "Thumbnail",
  "safety-instruction-form.remove-thumbnail": "Remove thumbnail",
  "safety-instruction-form.status": "Status",
  "safety-instruction-form.status-draft": "Draft",
  "safety-instruction-form.status-published": "Published",
  "safety-instruction-form.video": "Video",
  "safety-instruction-form.save-validation": "Please fix errors in the form.",
  "safety-instruction-form.save-error": "An error occurred while saving the safety instruction.",
  "safety-instruction-form.save-success": "Safety instruction saved successfully.",
  "safety-instruction-form.blocks": "Blocks",
  "safety-instruction-form.blocks.text": "Text",
  "safety-instruction-form.blocks.text-placeholder": "Enter text here",
  "safety-instruction-form.blocks.image": "Image",
  "safety-instruction-form.blocks.image.drop-image": "Drop image here",
  "safety-instruction-form.blocks.image.or-click-to-select": "or click to select",
  "safety-instruction-form.blocks.video": "Video",
  "safety-instruction-form.blocks.video.video-url": "Video URL",
  "safety-instruction-form.blocks.video.preview": "Video preview",
  "safety-instruction-form.blocks.video.unsupported": "Only https://youtube.com and https://vimeo.com videos are supported",
  "safety-instruction-form.blocks.multiple-choice-question": "Multiple Choice Question",
  "safety-instruction-form.blocks.mcq.question": "Question",
  "safety-instruction-form.blocks.mcq.question-placeholder": "Enter your question here",
  "safety-instruction-form.blocks.mcq.answers": "Answers",
  "safety-instruction-form.blocks.mcq.answer-placeholder": "Enter answer",
  "safety-instruction-form.blocks.mcq.correct": "Correct",
  "safety-instruction-form.blocks.mcq.add-answer": "Add Answer",
  "safety-instruction-form.blocks.mcq.all-correct-answers-required": "All correct answers must be selected",
  "safety-instruction-form.blocks.mcq.question-required": "Question is required",
  "safety-instruction-form.blocks.mcq.answer-required": "Answer is required",
  "safety-instruction-form.blocks.mcq.correct-answers-required": "At least one correct answer is required",
  "safety-instruction-form.blocks.page-separator": "Page Separator",
  "safety-instruction-form.blocks.page-separator-placeholder": "Enter page title",

  "menu.checklists": "Checklists",

  "checklists.title": "Checklists",
  "checklists.create": "New Checklist",
  "checklists.status": "Status",
  "checklists.organisation": "Organisation",
  "checklists.created-by": "Created by",
  "checklists.created-at": "Created at",
  "checklists.status.concept": "Concept",
  "checklists.status.published": "Published",

  "checklists.create-modal.header": "Create checklist",
  "checklists.create-modal.title": "Title",
  "checklists.create-modal.title.required": "Title is required",
  "checklists.create-modal.organisation": "Organisation",
  "checklists.create-modal.organisation.required": "Organisation is required",
  "checklists.create-modal.create": "Create",
  "checklists.create-modal.error.create-failed": "Failed to create checklist",

  "create-checklist-modal.error.create-failed": "Failed to create checklist",

  "checklists.edit.placeholder": "Checklist content editor will be implemented here. You can edit the title, description, and checklist items.",
  "checklists.edit.notFound": "Checklist not found",

  "checklists.delete-title": "Delete checklist",
  "checklists.delete-message": "Are you sure you want to delete this checklist? This action cannot be undone.",
  "checklists.delete-confirm": "Delete",
  "checklists.delete-success": "Checklist deleted successfully",
  "checklists.delete-error": "Failed to delete checklist",

  "checklists.publish": "Publish",
  "checklists.publish-title": "Publish checklist",
  "checklists.publish-message": "Are you sure you want to publish this checklist? Once published, the checklist items cannot be edited and status cannot be changed back.",
  "checklists.publish-confirm": "Publish",
  "checklists.publish-success": "Checklist published successfully",
  "checklists.publish-error": "Failed to publish checklist",
  "checklists.publish-error-new-checklist": "This is a new checklist. Please save it first before publishing.",
  "checklists.publish-error-unsaved-changes": "Please save your changes before publishing.",
  "checklists.publish-error-not-concept": "Only checklists in Concept status can be published.",

  "checklists.item.delete-title": "Delete item",
  "checklists.item.delete-message": "Are you sure you want to delete this checklist item?",
  "checklists.item.delete-confirm": "Delete",

  "checklists.save-success": "Checklist saved successfully",
  "checklists.save-error": "Failed to save checklist",

  "checklists.error.id-not-found": "Checklist ID not found",
  "checklists.error.load-failed": "Failed to load checklist",

  "checklist-form.title": "Title",
  "checklist-form.title.required": "Title is required",
  "checklist-form.title.maxlength": "Title cannot exceed 200 characters",
  "checklist-form.status": "Status",
  "checklist-form.description": "Description",
  "checklist-form.items": "Checklist Items",
  "checklist-form.item.placeholder": "Enter checklist item...",
  "checklist-form.item.required": "Item text is required",
  "checklist-form.item.maxlength": "Item text cannot exceed 500 characters",
  "checklist-form.item.move-up": "Move item up",
  "checklist-form.item.move-down": "Move item down",
  "checklist-form.item.remove": "Remove item",
  "checklist-form.add-item": "Add item",
  "checklist-form.save-validation": "Please fix the form errors before saving",

  "thesaurus.title": "Manage platform thesaurus",
  "thesaurus.add-node": "+ Add node",
  "thesaurus.error": "Failed to load thesaurus data",
  "thesaurus.edit-function": "Edit Function",
  "thesaurus.add-function": "Add Function",
  "thesaurus.function-name": "Function Name",
  "thesaurus.function-name-placeholder": "Enter function name",
  "thesaurus.function-description": "Description",
  "thesaurus.function-description-placeholder": "Enter function description",
  "thesaurus.synonyms": "Synonyms",
  "thesaurus.synonyms-placeholder": "Add synonyms",
  "thesaurus.non-selectable": "Non-selectable",
  "thesaurus.non-selectable-label": "This node cannot be selected as a function",
  "thesaurus.management-organisation": "Management Organisation",
  "thesaurus.select-organisation": "Select organisation",
  "thesaurus.load-organisations-error": "Error loading organisations",
  "thesaurus.save-edit-success": "Updated function",
  "thesaurus.save-new-success": "Created function",
  "thesaurus.save-error": "Failed to save function",
  "thesaurus.delete-title": "Delete Function",
  "thesaurus.delete-message": "Are you sure you want to delete this function? This action cannot be undone.",
  "thesaurus.delete-confirm": "Delete",
  "thesaurus.delete-success": "Function deleted successfully",
  "thesaurus.delete-error": "Failed to delete function",
  "thesaurus.cannot-delete-parent-function": "Cannot delete a function that has children. Please delete or move the children first.",

  "safety-requirements.title": "Safety Requirements",
  "safety-requirements.create": "New Safety Requirement",
  "safety-requirements.create-success": "Safety requirement created successfully",
  "safety-requirements.create-error": "Failed to create safety requirement",
  "safety-requirements.update-success": "Safety requirement updated successfully",
  "safety-requirements.update-error": "Failed to update safety requirement",
  "safety-requirements.delete-success": "Safety requirement deleted successfully",
  "safety-requirements.delete-error": "Failed to delete safety requirement",
  "safety-requirements.enable-requirement": "Enable requirement",
  "safety-requirements.disable-requirement": "Disable requirement",
  "safety-requirements.enable-success": "Organisation requirement enabled successfully",
  "safety-requirements.enable-error": "Failed to enable organisation requirement",
  "safety-requirements.disable-success": "Organisation requirement disabled successfully",
  "safety-requirements.disable-error": "Failed to disable organisation requirement",
  "safety-requirements.type.Certificates": "Certificates",
  "safety-requirements.type.Checklists": "Checklists",
  "safety-requirements.type.SafetyInstructions": "Safety Instructions",
  "safety-requirements.edit.title": "Edit safety requirement",
  "safety-requirements.form.title": "Title",
  "safety-requirements.form.title.placeholder": "Title of the safety requirement",
  "safety-requirements.form.type": "Type of safety requirement",
  "safety-requirements.form.target-audience": "Target audience",
  "safety-requirements.form.exclude": "Exclude",
  "safety-requirements.form.grace": "Grace type",
  "safety-requirements.target-audience.include-organisation": "Include everyone from organisation",
  "safety-requirements.target-audience.exclude-organisation": "Exclude everyone from organisation",
  "safety-requirements.target-audience.include-function": "Include everyone with function",
  "safety-requirements.target-audience.exclude-function": "Exclude everyone with function",
  "safety-requirements.target-audience.include-management": "Include management only",
  "safety-requirements.target-audience.exclude-management": "Exclude management",
  "safety-requirements.target-audience.include-everyone": "Include everyone",
  "safety-requirements.target-audience.exclude-everyone": "Exclude everyone",
  "safety-requirements.target-audience.everyone": "Everyone",
  "safety-requirements.target-audience.management": "Management",
  "safety-requirements.target-audience.organisation.placeholder": "Organisation",
  "safety-requirements.target-audience.function.placeholder": "Function",
  "safety-requirements.add": "Add safety requirement",
  "safety-requirements.page-title": "Safety requirements for",
  "safety-requirements.include": "Include:",
  "safety-requirements.exclude": "Exclude:",
  "safety-requirements.none": "None",
  "safety-requirements.grace-type.title": "Grace:",
  "safety-requirements.grace-type.None": "None",
  "safety-requirements.grace-type.Warning": "Warning",

  "organisation-safety-requirement.delete-title": "Delete Safety Requirement",
  "organisation-safety-requirement.delete-message": "Are you sure you want to delete this safety requirement? This action cannot be undone.",
  "organisation-safety-requirement.delete-confirm": "Delete",

  "project-safety-requirement.delete-title": "Delete Safety Requirement",
  "project-safety-requirement.delete-message": "Are you sure you want to delete this safety requirement? This action cannot be undone.",
  "project-safety-requirement.delete-confirm": "Delete",

  "safety-requirements.show-inherited-options": "Show options inherited from",

  "field.visible-in-app": "Field is visible in the app",

  "function-selector.title": "Select Function",
  "function-selector.search.placeholder": "Search functions...",
  "function-selector.search.clear": "Clear",
  "function-selector.search.no-results": "No results found",
  "function-selector.category": "Category",
  "function-selector.root": "All functions",
  "function-selector.select-this-category": "Select this category",
  "function-selector.cancel": "Cancel",

  "": ""
}
